<template>
  <div>
    <item-name :item="item" />
    <div class="flex items-center">
      <div>
        <validation-provider
          v-slot="{ errors, failed }"
          :name="item.name"
          :rules="validationRules"
        >
          <div>
            Hours
          </div>
          <div class="relative">
            <select
              :id="itemName + 'h'"
              :key="itemName + 'h'"
              v-model="hour"
              class="pl-4 pr-12 py-4 bg-gray-800 text-gray-100 w-full appearance-none rounded-none"
            >
              <option
                v-for="h in range(24, 0)"
                :key="h"
                :value="h"
              >
                {{ h }}
              </option>
            </select>
            <div class="absolute right-0 top-0 flex items-center h-full mr-3 pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 256 512"
                class="h-6 w-6 text-gray-500"
              >
                <path
                  fill="currentColor"
                  d="M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
                />
              </svg>
            </div>
          </div>
        </validation-provider>
      </div>
      <div class="px-1 self-end text-4xl">
        :
      </div>
      <div>
        <validation-provider
          v-slot="{ errors, failed }"
          :name="item.name"
          :rules="validationRules"
        >
          <div>
            Minutes
          </div>
          <div class="relative">
            <select
              :id="itemName + 'm'"
              :key="itemName + 'm'"
              v-model="minute"
              class="pl-4 pr-12 py-4 bg-gray-800 text-gray-100 w-full appearance-none rounded-none"
            >
              <option
                v-for="m in range(60, 0)"
                :key="m"
                :value="m"
              >
                {{ m }}
              </option>
            </select>
            <div class="absolute right-0 top-0 flex items-center h-full mr-3 pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 256 512"
                class="h-6 w-6 text-gray-500"
              >
                <path
                  fill="currentColor"
                  d="M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
                />
              </svg>
            </div>
          </div>
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import ItemMixin from './item-mixin'
import ItemName from './item-name'

export default {
  components: {
    ItemName
  },
  mixins: [
    ItemMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      hour: '00',
      minute: '00'
    }
  },
  computed: {
    time () {
      return this.hour + ':' + this.minute
    }
  },
  watch: {
    hour () {
      this.value = this.time
    },
    minute () {
      this.value = this.time
    }
  },
  created () {
    if (this.value) {
      let time = this.value.split(':')
      this.hour = time[0]
      this.minute = time[1]
    }
  },
  methods: {
    range (size, startAt = 0) {
      let pad = '00'
      return [...Array(size).keys()].map(i => {
        let input = i + startAt
        return (pad + input).slice(-pad.length)
      })
    }
  }
}
</script>
